import React from "react";

const PrivacyPolicy = () => {
  return (
    <div
      style={{
        padding: "50px 100px",
        fontFamily: "Arial, sans-serif",
        color: "#333",
      }}
    >
      <h2>Privacy Policy</h2>

      <section style={{ marginTop: "20px" }}>
        <p>
          <strong>1. Introduction:</strong> This Privacy Policy explains how{" "}
          <strong>DriveOme</strong> collects, uses, and protects your personal
          information when you use our mobility app to book or offer rides.
        </p>
      </section>

      <section style={{ marginTop: "20px" }}>
        <p>
          <strong>2. Information We Collect:</strong>
        </p>
        <ul>
          <li>
            <strong>Personal Info:</strong> Name, phone number, email, profile
            picture, vehicle and license details (for drivers).
          </li>
          <li>
            <strong>Location Data:</strong> We collect real-time GPS data to
            match riders with drivers and track live trips.
          </li>
          <li>
            <strong>Background Location:</strong> With your permission, we may
            access your location even when the app is in background (for trip
            tracking and safety).
          </li>
          <li>
            <strong>Payment Info:</strong> UPI, card details (securely via
            payment gateways), wallet transactions.
          </li>
          <li>
            <strong>Device Info:</strong> OS version, device ID, IP address,
            crash logs.
          </li>
          <li>
            <strong>Media Access:</strong> Camera/gallery for profile photo, ID
            upload (if applicable).
          </li>
        </ul>
      </section>

      <section style={{ marginTop: "20px" }}>
        <p>
          <strong>3. How We Use Your Information:</strong>
        </p>
        <ul>
          <li>To facilitate ride booking and driver allocation.</li>
          <li>To provide real-time trip tracking and support.</li>
          <li>To process payments and maintain transaction records.</li>
          <li>To verify driver identities and ensure safety.</li>
          <li>To send trip notifications, promotions, and alerts.</li>
        </ul>
      </section>

      <section style={{ marginTop: "20px" }}>
        <p>
          <strong>4. Sharing Your Information:</strong>
        </p>
        <ul>
          <li>
            With drivers/riders for trip coordination (e.g., name, location,
            phone number).
          </li>
          <li>
            With third-party providers (e.g., payment gateways, analytics
            tools).
          </li>
          <li>With emergency contacts (if enabled by user).</li>
          <li>With law enforcement, if required by applicable laws.</li>
        </ul>
      </section>

      <section style={{ marginTop: "20px" }}>
        <p>
          <strong>5. Data Retention:</strong> We retain data as long as your
          account is active or as needed to comply with legal, safety, and fraud
          prevention requirements.
        </p>
      </section>

      <section style={{ marginTop: "20px" }}>
        <p>
          <strong>6. Data Security:</strong> We use encryption, secure servers,
          and strict access controls to protect your data. No method of
          transmission is 100% secure, so we encourage you to use strong
          passwords and stay aware.
        </p>
      </section>

      <section style={{ marginTop: "20px" }}>
        <p>
          <strong>7. Your Rights:</strong> You may view, update, or delete your
          personal information by contacting us at{" "}
          <a href="mailto:DriveOme@gmail.com">DriveOme@gmail.com</a>.
        </p>
      </section>

      <section style={{ marginTop: "20px" }}>
        <p>
          <strong>8. Children’s Privacy:</strong> Our services are not intended
          for children under the age of 13. We do not knowingly collect their
          data. If found, we will delete it immediately.
        </p>
      </section>

      <section style={{ marginTop: "20px" }}>
        <p>
          <strong>9. Third-Party Services:</strong> We may use external services
          like Google Maps, Firebase, Razorpay, etc., which have their own
          privacy policies. We encourage you to review them separately.
        </p>
      </section>

      <section style={{ marginTop: "20px" }}>
        <p>
          <strong>10. Changes to this Policy:</strong> We may update this
          Privacy Policy from time to time. Updates will be posted on this page
          with the revised date.
        </p>
      </section>

      <section style={{ marginTop: "20px" }}>
        <p>
          <strong>11. Contact Us:</strong> For any questions or concerns about
          this Privacy Policy, email us at{" "}
          <a href="mailto:DriveOme@gmail.com">DriveOme@gmail.com</a>.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
